export const DISPUTE_STATUSES = [
  { value: "open", label: "Open", cls: "bg-sky-500/15 text-sky-300" },
  { value: "under_review", label: "Under Review", cls: "bg-amber-500/15 text-amber-300" },
  { value: "evidence_requested", label: "Evidence Requested", cls: "bg-orange-500/15 text-orange-300" },
  { value: "evidence_submitted", label: "Evidence Submitted", cls: "bg-cyan-500/15 text-cyan-300" },
  { value: "resolved", label: "Resolved", cls: "bg-emerald-500/15 text-emerald-300" },
  { value: "rejected", label: "Rejected", cls: "bg-rose-500/15 text-rose-300" },
  { value: "closed", label: "Closed", cls: "bg-slate-500/20 text-slate-300" },
];

export const isDisputeClosed = (s) => ["resolved", "rejected", "closed"].includes(s);

export function DisputeBadge({ status }) {
  const s = DISPUTE_STATUSES.find((x) => x.value === status) || DISPUTE_STATUSES[0];
  return <span data-testid={`dispute-status-${status}`} className={`rounded-full px-2.5 py-0.5 text-xs font-mono whitespace-nowrap ${s.cls}`}>{s.label}</span>;
}
